import { addCloudinaryBlurredBackgroundPadding } from '@/utils/getCloudinaryUrlWithBlurredBackgroundPadding';

export function getPaddedBackgroundImageUrl(
  imageUrl: string,
  height: number,
  width: number
): string {
  const blur = 1000;
  const opacity = 70;
  const aspectRatio = 1;
  return addCloudinaryBlurredBackgroundPadding(
    imageUrl,
    height,
    width,
    blur,
    opacity,
    aspectRatio
  );
}

export function getPaddedBackgroundImageUrl_200x200(imageUrl: string): string {
  const width = 200;
  const height = 200;
  return getPaddedBackgroundImageUrl(imageUrl, height, width);
}
